<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" class="scaling-svg">
      <path
        d="M7,14A7,7,0,0,1,4.667.4a.7.7,0,1,1,.466,1.318,5.6,5.6,0,1,0,7.148,7.149.7.7,0,1,1,1.32.466A7.012,7.012,0,0,1,7,14Zm6.3-7H7.7A.7.7,0,0,1,7,6.3V.7A.7.7,0,0,1,7.7,0,6.307,6.307,0,0,1,14,6.3.7.7,0,0,1,13.3,7ZM8.4,1.45V5.6h4.15A4.924,4.924,0,0,0,8.4,1.45Z"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ReportIcon extends Vue {}
</script>

<style>
</style>
